import React from "react";

export default function NumberFormatted(props) {
    var decimals = props.decimals == null ? 2 : props.decimals;    
    var nf = new Intl.NumberFormat('fr-CH', { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping: true, });
    var value = nf.format(props.number);
    var formatted = !isNaN(props.number) ? value.replace(",", ".").replaceAll(" ", "'") : 0;
    return (
        <>
            {props.fn ? props.fn(formatted) : formatted}
        </>
    );
}